// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x596U{flex:1;display:flex;flex-direction:column;gap:24px;align-items:stretch}.mYRM5{gap:8px;align-items:center;text-align:center}.jjSmH{gap:16px;padding:24px 16px;height:204px;width:100%}.yYzsI{display:flex;align-items:center;justify-content:center;padding:8px;border-radius:100px;background-color:#f4f4f7}.oBQ4P{color:#696992}.gNB41{align-items:center;gap:8px;width:100%}.msbdO{color:#9393b1}.gKbyL{padding-top:4px !important}._kmX2{align-items:center;padding:8px 0}.vM4LX{margin-top:16px;margin-bottom:8px}.tIc8y{display:inline-flex;align-items:center;gap:6px;padding:4px 12px;border-radius:16px;background-color:#f4f4f7;color:var(--text-secondary, #696992)}.hlNVU{width:100%;margin:16px 0}.KMn5C{width:100%;align-self:stretch;gap:12px;padding:0 32px;box-sizing:border-box}.KMn5C.ZOsH0{padding:0}.taDTu{display:flex;align-items:center;gap:8px}.Bvkdj{width:12px;height:12px;border-radius:50%;background-color:#9393b1;background-clip:padding-box;border:4px solid transparent;flex-shrink:0;box-sizing:border-box}.Bvkdj.nqBJ6{background-color:#6942f8;border-color:#e1d9fe;animation:tupaq 1.5s ease-out infinite}@keyframes tupaq{0%{box-shadow:0 0 0 0 rgba(105,66,248,.4)}100%{box-shadow:0 0 0 4px rgba(105,66,248,0)}}.elXcE{width:12px;height:12px;display:flex;align-items:center;justify-content:center;color:#6942f8;flex-shrink:0}.eBAGw{padding-bottom:4px}.ZfOOZ{flex:1;display:flex;flex-direction:column}.kUCLN{padding:0 32px;flex:1;display:flex;flex-direction:column}._xYVq{align-items:center}.R7XPV{display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;background-color:#e1d9fe;margin-bottom:12px}.AEMNG{margin-bottom:8px;text-align:center}.suWkf{text-align:center;max-width:400px}._3bPKD{display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:16px}.XY9Up{display:flex;gap:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"uploadColumn": `x596U`,
	"uploadHeader": `mYRM5`,
	"uploadDropzone": `jjSmH`,
	"uploadIconCircle": `yYzsI`,
	"uploadIcon": `oBQ4P`,
	"dropzoneTextBlock": `gNB41`,
	"hint": `msbdO`,
	"uploadModalBody": `gKbyL`,
	"analyzingContent": `_kmX2`,
	"analyzingTitle": `vM4LX`,
	"fileNameChip": `tIc8y`,
	"divider": `hlNVU`,
	"stepsContainer": `KMn5C`,
	"stepsContainerMobile": `ZOsH0`,
	"step": `taDTu`,
	"stepDot": `Bvkdj`,
	"stepDotActive": `nqBJ6`,
	"stepDotPulse": `tupaq`,
	"stepCheckmark": `elXcE`,
	"shellHeader": `eBAGw`,
	"shellBody": `ZfOOZ`,
	"shellContent": `kUCLN`,
	"errorContent": `_xYVq`,
	"errorIconContainer": `R7XPV`,
	"errorTitle": `AEMNG`,
	"errorDescription": `suWkf`,
	"feedbackRow": `_3bPKD`,
	"thumbButtons": `XY9Up`
};
export default ___CSS_LOADER_EXPORT___;
